import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum ProgramEdgeType {
  ADVANCES_TO = 'advances_to',
  BUILDS_SKILLS_FOR = 'builds_skills_for'
}

export enum RoleLevel {
  ENTRY = 'ENTRY',
  FRONTLINE = 'FRONTLINE',
  MID = 'MID',
  SENIOR = 'SENIOR'
}

export enum RoleEdgeType {
  ENROLLS_IN = 'enrolls_in'
}

export type ConnectRolesByProgramInput = {
  employerId: Scalars['String'];
  fromRoleTitle: Scalars['String'];
  programUuid: Scalars['String'];
  toRoleTitle: Scalars['String'];
};

export type ConnectSkillToProgramInput = {
  programUuid: Scalars['ID'];
  relevanceScore: Scalars['Float'];
  relevanceTier: RelevanceTier;
  skillId: Scalars['ID'];
};

export enum RelevanceTier {
  HIGH = 'High',
  LOW = 'Low',
  MEDIUM = 'Medium'
}

export type ProgramInput = {
  name: Scalars['String'];
  uuid: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};

export type ProgramToRoleEdgeInput = {
  edgeType: ProgramEdgeType;
  employerId: Scalars['ID'];
  pathwayId: Scalars['ID'];
  pathwayName: Scalars['String'];
  programId: Scalars['ID'];
  roleId: Scalars['ID'];
};

export type SkillInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RoleInput = {
  employerId: Scalars['ID'];
  genericName: Scalars['String'];
  level: RoleLevel;
  pathwayId: Scalars['ID'];
  pathwayName: Scalars['String'];
  title: Scalars['String'];
  uuid?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
};

export type GetProgramOutQueryVariables = Exact<{
  programId: Scalars['ID'];
  edgeType: ProgramEdgeType;
  employerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProgramOutQuery = { getProgramOut: Array<{ id?: string | null, title: string, pathwayId: string, pathwayName: string } | null> };

export type GetRolesForProgramsQueryVariables = Exact<{
  employerId: Scalars['ID'];
  programIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
}>;


export type GetRolesForProgramsQuery = { rolesForPrograms: Array<{ programId: string, roles: Array<{ id?: string | null, genericName: string, name?: string | null, pathwayId: string, pathwayName: string } | null> }> };


export const GetProgramOutDocument = gql`
    query getProgramOut($programId: ID!, $edgeType: ProgramEdgeType!, $employerId: ID) {
  getProgramOut(programId: $programId, edgeType: $edgeType, employerId: $employerId) {
    id
    title
    pathwayId
    pathwayName
  }
}
    `;

/**
 * __useGetProgramOutQuery__
 *
 * To run a query within a React component, call `useGetProgramOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramOutQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      edgeType: // value for 'edgeType'
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useGetProgramOutQuery(baseOptions: Apollo.QueryHookOptions<GetProgramOutQuery, GetProgramOutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramOutQuery, GetProgramOutQueryVariables>(GetProgramOutDocument, options);
      }
export function useGetProgramOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramOutQuery, GetProgramOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramOutQuery, GetProgramOutQueryVariables>(GetProgramOutDocument, options);
        }
export type GetProgramOutQueryHookResult = ReturnType<typeof useGetProgramOutQuery>;
export type GetProgramOutLazyQueryHookResult = ReturnType<typeof useGetProgramOutLazyQuery>;
export type GetProgramOutQueryResult = Apollo.QueryResult<GetProgramOutQuery, GetProgramOutQueryVariables>;
export const GetRolesForProgramsDocument = gql`
    query getRolesForPrograms($employerId: ID!, $programIds: [ID]!, $version: String) {
  rolesForPrograms(employerId: $employerId, programIds: $programIds, version: $version) {
    programId
    roles {
      id
      genericName
      name
      pathwayId
      pathwayName
    }
  }
}
    `;

/**
 * __useGetRolesForProgramsQuery__
 *
 * To run a query within a React component, call `useGetRolesForProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesForProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesForProgramsQuery({
 *   variables: {
 *      employerId: // value for 'employerId'
 *      programIds: // value for 'programIds'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetRolesForProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetRolesForProgramsQuery, GetRolesForProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesForProgramsQuery, GetRolesForProgramsQueryVariables>(GetRolesForProgramsDocument, options);
      }
export function useGetRolesForProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesForProgramsQuery, GetRolesForProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesForProgramsQuery, GetRolesForProgramsQueryVariables>(GetRolesForProgramsDocument, options);
        }
export type GetRolesForProgramsQueryHookResult = ReturnType<typeof useGetRolesForProgramsQuery>;
export type GetRolesForProgramsLazyQueryHookResult = ReturnType<typeof useGetRolesForProgramsLazyQuery>;
export type GetRolesForProgramsQueryResult = Apollo.QueryResult<GetRolesForProgramsQuery, GetRolesForProgramsQueryVariables>;